var Mutex = /** @class */ (function () {
    function Mutex() {
        this._locked = false;
        this._waiters = [];
    }
    Mutex.prototype.isLocked = function () {
        return this._locked;
    };
    Mutex.prototype.acquire = function () {
        var _this = this;
        var waiter = new Promise(function (r) { return _this._waiters.push(r); });
        if (!this._locked) {
            this.dispatchNext();
        }
        return waiter;
    };
    Mutex.prototype.dispatchNext = function () {
        var _this = this;
        if (this._waiters.length > 0) {
            this._locked = true;
            var first = this._waiters.shift();
            if (first)
                first(function () { return _this.dispatchNext(); });
        }
        else {
            this._locked = false;
        }
    };
    return Mutex;
}());
export { Mutex };
//# sourceMappingURL=Mutex.js.map